var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDywanyiwykadzinyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.78 47.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.78,11.24v-2.81h-5.62v-2.81H14.05v5.62h16.86v1.41c0,2.32,1.89,4.22,4.22,4.22h1.41v19.67h-1.41c-2.32,0-4.22,1.89-4.22,4.22v1.41H14.05s0,.01,0,.01c0,2.15-.82,4.12-2.15,5.61h30.26v-2.81h5.62v-2.81h-5.62v-2.81h5.62v-2.81h-5.62v-2.81h5.62v-2.81h-5.62v-2.81h5.62v-2.81h-5.62v-2.81h5.62v-2.81h-5.62v-2.81h5.62v-2.81h-5.62v-2.81h5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.62,0C2.52,0,0,2.52,0,5.62v30.26c3.2-2.87,8.04-2.87,11.24,0V5.62c0-3.1-2.52-5.62-5.62-5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.11,26.7c0-3.1-2.52-5.62-5.62-5.62h-8.43v11.24h8.43c3.1,0,5.62-2.52,5.62-5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.73,33.87v-14.34c-2.75-.56-4.92-2.73-5.48-5.48h-14.19v4.22h8.43c4.65,0,8.43,3.78,8.43,8.43s-3.78,8.43-8.43,8.43h-8.43v4.22h14.19c.56-2.75,2.73-4.92,5.48-5.48h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.62,
    cy: 42.16,
    r: 5.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDywanyiwykadzinyIcon);
export default __webpack_public_path__ + "static/media/Dywany i wykładziny_icon.19499e1317814ece1534336b1ebd7613.svg";
export { ForwardRef as ReactComponent };